<template>
        <div class="select_color">
            <div>
                 <div class="white">
                    <div></div><p>オフホワイト</p>
                 </div>
                 <div class="dark_brown">
                     <div></div><p>ダークブラウン</p>
                 </div>
                 <div class="soft_silver">
                     <div></div><p>ソフトシルバー</p>
                 </div>
                 <div class="black">
                     <div></div><p>ブラック</p>
                 </div>
            </div>
        </div>
</template>

<script>
    import { mapMutations , mapActions} from 'vuex'
    import SelectPosition from "./AddItem/SelectPosition";

    export default {
        name: "SelectPartialColor",
        components: {SelectPosition},
        data: () => ({
        }),
        destroyed() {
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations('simulator', ["deleteTempItem"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["commitTempItem"]),
            async addItem() {
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    .select_color {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
            margin: auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;
               > div{
                   width: calc(50% - 40px);
                   display: flex;
                   justify-content: center;
                   padding: 10px;
                   border-radius: 3px;
                   border: 1px solid #000;
                   margin-bottom: 20px;
                   background-color: #fff;
                   > div{
                       width: 30%;
                       border: 1px solid #000;
                       border-radius: 3px;
                       margin-right: 10px;
                   }
                   p{
                       min-width: 40%;
                       font-size: 1vw;
                   }
                }
            @media (max-width: 739px) {
                > div{
                    width: calc(50% - 20px);
                    padding: 5px;
                    margin-bottom: 10px;
                    p{
                        font-size: 10px;
                    }
                }
            }
            > div.white div{
                background-color: #ffffff;
            }
            > div.dark_brown div{
                background-color: #5A4A3F;
            }
            > div.soft_silver div{
                background-color: #9FA0A0;
            }
            > div.black div{
                background-color: #231815;
            }

        }
        }
</style>
